var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var isLoggerEnabled = false;
export var configureLogger = function (isEnabled) {
  isLoggerEnabled = isEnabled;
};
export var logger = {
  debug: function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (isLoggerEnabled) {
      // eslint-disable-next-line no-restricted-syntax, no-console
      console.debug.apply(console, args);
    }
  },
  info: function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (isLoggerEnabled) {
      // eslint-disable-next-line no-restricted-syntax, no-console
      console.info.apply(console, __spreadArray(['%c  DEV-ENV-LOG:  ', 'background-color: purple; color: white;', '\n'], args, false));
    }
  },
  log: function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (isLoggerEnabled) {
      // eslint-disable-next-line no-restricted-syntax, no-console
      console.log.apply(console, args);
    }
  },
  table: function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (isLoggerEnabled) {
      // eslint-disable-next-line no-restricted-syntax, no-console
      console.table.apply(console, args);
    }
  },
  warn: console.warn,
  error: console.error
};